import { createAction, props } from '@ngrx/store';

import { LabResults } from './../../models/overview.model';

export const loadLabResults = createAction(
  '[Overview] load lab results',
  props<{ keyword: string; pageNumber: number; pageSize: number }>(),
);

export const loadLabResultsSuccess = createAction(
  '[Overview] load lab results success',
  props<{ labResults: LabResults }>(),
);

export const downloadReport = createAction('[Overview] download report', props<{ id: number }>());
export const downloadReportSuccess = createAction('[Overview] download report success');
export const downloadReportFailed = createAction('[Overview] download report failed');
